// constants
import { AssociatedTypeActionTypes } from './constants';
import { AssociateList as AssociateListData } from 'src/types/associateList';

export type AssociatedTypeActionType = {
    type:
        | AssociatedTypeActionTypes.API_RESPONSE_SUCCESS
        | AssociatedTypeActionTypes.API_RESPONSE_ERROR
        | AssociatedTypeActionTypes.GET_ASSOCIATED_LIST
        | AssociatedTypeActionTypes.ADD_ASSOCIATED_LIST
        | AssociatedTypeActionTypes.EDIT_ASSOCIATED_LIST
        | AssociatedTypeActionTypes.GET_ASSOCIATED_LISTS
        | AssociatedTypeActionTypes.GET_ASSOCIATED_INST_LISTS
        | AssociatedTypeActionTypes.GET_REFER_DR_LISTS
        | AssociatedTypeActionTypes.GET_USER_REFER_DR_LISTS
        | AssociatedTypeActionTypes.RESET
        | AssociatedTypeActionTypes.RESET_SUCCESS
        | AssociatedTypeActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const associatedListApiResponseSuccess = (
    actionType: string,
    data: AssociateListData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const associatedListApiResponseError = (
    actionType: string,
    data: AssociateListData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addAssociatedList = (params: any): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.ADD_ASSOCIATED_LIST,
    payload: params,
});

export const editAssociatedList = (params: any): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.EDIT_ASSOCIATED_LIST,
    payload: params,
});

export const getAssociatedList = (params: any): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.GET_ASSOCIATED_LIST,
    payload: params,
});

export const getAssociatedLists = (params: any): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.GET_ASSOCIATED_LISTS,
    payload: params,
});

export const getAssociatedInstLists = (params: any): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.GET_ASSOCIATED_INST_LISTS,
    payload: params,
});

export const getDrInstLists = (params: any): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.GET_REFER_DR_LISTS,
    payload: params,
});

export const getUserAllDrList = (params: any): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.GET_USER_REFER_DR_LISTS,
    payload: params,
});

export const resetAssociatedList = (): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.RESET,
    payload: {},
});

export const resetAssociatedListSuccess = (): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetAssociatedListError = (): AssociatedTypeActionType => ({
    type: AssociatedTypeActionTypes.RESET_ERROR,
    payload: {},
});
